<template>
    <div v-if="showPreorderInfo" class="pre-order">
        <div class="pick-up-time">
            <div>{{ deliveryAddressFirstLine }}</div>
            <div>{{ deliveryAddressSecondLine }}</div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { SchedulingMode } from "@/data/model/Enums";
    import type { IOrderApplication } from "@/data/model/OrderApplication";
    import { computed } from "vue";
    import type { IDeliveryAddress } from "@/data/model/Customer";

    const props = defineProps<{
        deliveryAddress: IDeliveryAddress | undefined;
        orderApplication: IOrderApplication | undefined;
    }>();

    const schedulingMode = computed(() => props.orderApplication?.schedulingMode);
    const showPreorderInfo = computed(() => {
        return (
            schedulingMode.value != null &&
            schedulingMode.value != SchedulingMode.None &&
            props.deliveryAddress != null
        );
    });
    const deliveryAddressFirstLine = computed(() =>
        showPreorderInfo.value != null
            ? `${props.deliveryAddress!.street} ${props.deliveryAddress!.addressDetails ?? ""}`.trim()
            : "");

    const deliveryAddressSecondLine = computed(() =>
        showPreorderInfo.value != null
            ? `${props.deliveryAddress!.postalCode} ${props.deliveryAddress!.city}`.trim()
            : ""
    );
</script>

<style lang="scss">
    .order-received-popover-content .pre-order {
        margin-top: 6px;

        .pick-up-time {
            text-align: center;
            font-size: 14px;
        }
    }
</style>
